import { Pipe, PipeTransform, ChangeDetectorRef, NgZone } from '@angular/core';

@Pipe({
  name: 'timeAgo'
})
export class TimeAgoPipe implements PipeTransform {

  private timer: number;

  constructor(private changeDetectorRef: ChangeDetectorRef, private ngZone: NgZone) { }

  transform(value: any, args?: any): any {
    let date = new Date(value);
    let now = new Date();
    let seconds = Math.round(Math.abs((now.getTime() - date.getTime()) / 1000));
    let timeToUpdate = (Number.isNaN(seconds)) ? 1000 : this.getSecondsUntilUpdate(seconds) * 1000;
    this.timer = this.ngZone.runOutsideAngular(() => {
      if (typeof window !== 'undefined') {
        return window.setTimeout(() => {
          this.ngZone.run(() => this.changeDetectorRef.markForCheck());
        }, timeToUpdate);
      }
      return null;
    });
    let minutes = Math.round(Math.abs(seconds / 60));
    let hours = Math.round(Math.abs(minutes / 60));
    let days = Math.round(Math.abs(hours / 24));
    let months = Math.round(Math.abs(days / 30.416));
    let years = Math.round(Math.abs(days / 365));
    if (Number.isNaN(seconds)) {
      return '';
    } else if (seconds <= 45) {
      return 'Hace unos seg';
    } else if (seconds <= 90) {
      return 'Hace 1 min';
    } else if (minutes <= 45) {
      return 'Hace ' + minutes + ' min';
    } else if (minutes <= 90) {
      return 'Hace 1 hr';
    } else if (hours <= 22) {
      return 'Hace ' + hours + ' hrs';
    } else if (hours <= 36) {
      return 'Hace 1 día';
    } else if (days <= 25) {
      return 'Hace ' + days + ' días';
    } else if (days <= 45) {
      return 'Hace 1 mes';
    } else if (days <= 345) {
      return 'Hace ' + months + ' meses';
    } else if (days <= 545) {
      return 'Hace 1 año';
    } else { // (days > 545)
      return 'Hace ' + years + ' años';
    }
  }

  ngOnDestroy(): void {
    this.removeTimer();
  }
  private removeTimer() {
    if (this.timer) {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }

  private getSecondsUntilUpdate(seconds: number) {
    let min = 60;
    let hr = min * 60;
    let day = hr * 24;
    if (seconds < min) { // less than 1 min, update every 2 secs
      return 2;
    } else if (seconds < hr) { // less than an hour, update every 30 secs
      return 30;
    } else if (seconds < day) { // less then a day, update every 5 mins
      return 300;
    } else { // update every hour
      return 3600;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/time-ago.pipe.ts